import Modal from './Modal';
/**
 * The `FormModal` component displays a modal dialog, wrapped in a form.
 * Subclasses should implement the `className`, `title`, and `content` methods.
 */
export default class FormModal extends Modal {
  wrapper(children) {
    return m("form", {
      onsubmit: this.onsubmit.bind(this)
    }, children);
  }

  /**
   * Handle the modal form's submit event.
   */
  onsubmit(e) {
    // ...
  }

  /**
   * Callback executed when the modal is shown and ready to be interacted with.
   *
   * @remark Focuses the first input in the modal.
   */
  onready() {
    this.$().find('input, select, textarea').first().trigger('focus').trigger('select');
  }

  /**
   * Shows an alert describing an error returned from the API, and gives focus to
   * the first relevant field involved in the error.
   */
  onerror(error) {
    this.alertAttrs = error.alert;
    m.redraw();
    if (error.status === 422 && error.response?.errors) {
      this.$('form [name=' + error.response.errors[0].source.pointer.replace('/data/attributes/', '') + ']').trigger('select');
    } else {
      this.onready();
    }
  }
}
flarum.reg.add('core', 'common/components/FormModal', FormModal);